import React, { useState, useEffect } from "react"
import Select from "react-select"

import { SingleOption, customStyles, parseBudat, getLocaleStringNumber } from "../../utils/utils.js"
import { getAlertIconVentas } from "../../utils/get"
import { showGreyBackground, scrollTo } from "../../utils/windows"

import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"

export const RegularizacionMobile = ({
  transacciones, 
  selectedTransaccion, 
  changeSelectedTransaccion, 
  regularizarVenta,
  editarRegularizacion,
  hasRegularizacion,
  params,
  fechaParams,
  goBackStep2
}) => {
  const hasTransacciones = transacciones && transacciones.length > 0
  const emptyMessage = transacciones
    ? "La búsqueda no arrojó resultados"
    : "Realiza una búsqueda por fecha."

  const selectTransaction = (event, trx) => {
    event.stopPropagation()
    if (trx.DISABLE_REG !== 1) {
      changeSelectedTransaccion(trx)
    }
  }

  const showSolicitud = () => {
    regularizarVenta()
    scrollTo(0, 0)
    showGreyBackground()
  }

  return (
    <div className="regularizacion-responsive-flow hide-desktop">
      <div className="big-subtitle regularizacion-responsive-title">
        Regularizar Ventas
        {params && 
          <button
            className="main-button hallow mobile-button show-only-tablet seleccionar-pedidos-tablet-button"
            onClick={goBackStep2}>
            Volver ({parseBudat(fechaParams)})
          </button>
        }
        <hr className="title-separator-line" />
      </div>
      <table className="responsive-table separated-th-table">
        <thead>
          <tr>
            <th>
              <div className="th-data">Documento Venta</div>
            </th>
            <th>
              <div className="th-data">Material</div>
            </th>
            <th>
              <div className="th-data">Alerta</div>
            </th>
            <th>
              <div className="th-data">Selecc.</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {hasTransacciones &&
            transacciones.map((trx, index) => {
              const isSelected = trx.ID_TRANSACCION === selectedTransaccion?.ID_TRANSACCION

              return (
                <React.Fragment key={`trx-${trx.ID_TRANSACCION || index}`}>
                  <tr className={isSelected ? "selected-row" : ""}>
                    <td>{trx.DOCUMENTO_VENTA}</td>
                    <td>{trx.MATERIAL}</td>
                    <td>{getAlertIconVentas(trx.ALERTA)}</td>
                    <td>
                      <input
                        type="radio"
                        name="selected-pedido-check-responsive"
                        value={trx.ID_TRANSACCION}
                        checked={isSelected}
                        disabled={trx.DISABLE_REG===1}
                        onClick={(e) => selectTransaction(e, trx)}
                        onChange={(e) => selectTransaction(e, trx)}
                      />
                    </td>
                  </tr>
                  {index < transacciones.length - 1 &&
                    <tr className="separator-table-row regularizacion-row-separator">
                      <td colSpan="4" />
                    </tr>
                  }
                </React.Fragment>
              )
            })
          }
          {!hasTransacciones &&
            <tr className="regularizacion-empty-row">
              <td colSpan="4">{emptyMessage}</td>
            </tr>
          }
        </tbody>
      </table>
      <hr className="regularizacion-responsive-actions-separator show-only-tablet" />
      <div className="responsive-actions responsive-actions-tablet">
        <button
          className={`main-button mobile-button tablet-button ${!selectedTransaccion && "disabled"}`}
          onClick={showSolicitud}
          disabled={selectedTransaccion?hasRegularizacion(selectedTransaccion):true}
        >
          Regularizar venta
        </button>
        <button
          className={`main-button mobile-button tablet-button ${!selectedTransaccion && "disabled"}`}
          onClick={() => editarRegularizacion(selectedTransaccion)}
          disabled={selectedTransaccion?!hasRegularizacion(selectedTransaccion):true}
        >
          Editar Regularización
        </button>
      </div>
    </div>
  )
}
